import React from 'react'
import { Box, TextField, FormLabel, FormControl } from '@mui/material'
import { DatePicker, DateTimePicker } from '@mui/x-date-pickers'
import { getLabel, getComputedWidth } from './utils'

export const CommonDatePicker = ({
  id,
  value,
  onChange,
  onBlur,
  error = '',
  helperText = '',
  variant = 'date',
  label = 'Select Date',
  required = false,
  width,
  fullWidth = true,
  inputFormat,
  placeholder = 'MM/DD/YYYY',
  onAccept,
  ...props
}) => {
  const computedWidth = getComputedWidth(width, fullWidth)

  // Default formats
  const defaultDateFormat = 'MM/dd/yyyy'
  const defaultDateTimeFormat = 'MM/dd/yyyy hh:mm a'

  return (
    <Box id={id} data-testid={id} sx={{ width: computedWidth }}>
      <FormControl fullWidth error={!!error}>
        <FormLabel>{getLabel(label, required)}</FormLabel>
        {variant === 'date' ? (
          <DatePicker
            {...props}
            value={value ?? null}
            onAccept={onAccept}
            onChange={date => onChange(date)}
            format={inputFormat || defaultDateFormat}
            enableAccessibleFieldDOMStructure={false}
            slots={{ textField: TextField }}
            slotProps={{
              textField: {
                fullWidth: fullWidth,
                disabled: props.disabled,
                readOnly: props.readOnly,
                error: !!error,
                ...(error || helperText
                  ? { helperText: error || helperText }
                  : {}),
                onBlur: onBlur,
                placeholder: placeholder || inputFormat || defaultDateFormat,
              },
            }}
          />
        ) : (
          <DateTimePicker
            {...props}
            value={value ?? null}
            onAccept={onAccept}
            onChange={(date, inputValue) => onChange(date, inputValue)}
            inputFormat={inputFormat || defaultDateTimeFormat}
            enableAccessibleFieldDOMStructure={false}
            slots={{ textField: TextField }}
            slotProps={{
              textField: {
                fullWidth: fullWidth,
                disabled: props.disabled,
                readOnly: props.readOnly,
                error: !!error,
                ...(error || helperText
                  ? { helperText: error || helperText }
                  : {}),
                onBlur: onBlur,
                placeholder:
                  placeholder || inputFormat || defaultDateTimeFormat,
              },
            }}
          />
        )}
      </FormControl>
    </Box>
  )
}
